var catorder = [{
	"order": 0,
	"type": "section",
	"label": "Section",
	"title": "CATEGORY"
}, {
	"order": 1,
	"type": "customlink",
	"label": "Custom Link",
	"title": "View All",
	"url": "\/collections\/all"
}, {
	"order": 2,
	"type": "category",
	"label": "Best Sellers",
	"handle": "best-sellers",
	"id": 353547334
}, {
	"order": 3,
	"type": "category",
	"label": "Gifting Ideas",
	"handle": "gifting-ideas",
	"id": 19680559142
}, {
	"order": 4,
	"type": "category",
	"label": "What's New",
	"handle": "whats-new",
	"id": 353564806
}, {
	"order": 5,
	"type": "category",
	"label": "Acne Collections",
	"handle": "acne-collections",
	"id": 392914694
}, {
	"order": 6,
	"type": "category",
	"label": "Acne Spot Treatments",
	"handle": "acne-spot-treatments",
	"id": 353563590
},  {
	"order": 7,
	"type": "category",
	"label": "Body Care",
	"handle": "body-care",
	"id": 353563078
},
  {
	"order": 7,
	"type": "category",
	"label": "Shower",
	"handle": "shower",
	"id": 289535000635
}, {
	"order": 8,
	"type": "category",
	"label": "Cleansers",
	"handle": "cleansers",
	"id": 353547462
}, {
	"order": 9,
	"type": "category",
	"label": "Exfoliants",
	"handle": "exfoliants",
	"id": 353547590
}, {
	"order": 10,
	"type": "category",
	"label": "Eye Care Treatments",
	"handle": "eye-care-treatments",
	"id": 353562886
}, {
	"order": 11,
	"type": "category",
	"label": "Masques",
	"handle": "masques",
	"id": 353563206
}, {
	"order": 12,
	"type": "category",
	"label": "Moisturizers",
	"handle": "moisturizers",
	"id": 353563398
}, {
	"order": 13,
	"type": "category",
	"label": "Skin Accessories",
	"handle": "skin-accessories",
	"id": 353563718
}, {
	"order": 14,
	"type": "category",
	"label": "Specialty Serums",
	"handle": "specialty-serums",
	"id": 353563846
}, {
	"order": 15,
	"type": "category",
	"label": "Sun Protection",
	"handle": "sun-protection",
	"id": 353564294
}, {
	"order": 16,
	"type": "category",
	"label": "Toners",
	"handle": "toners",
	"id": 353564678
},{
	"order": 18,
	"type": "category",
	"label": "We Made Too Much",
	"handle": "we-made-too-much",
	"id": 290359803963
}, {
	"order": 18,
	"type": "category",
	"label": "Final Sale",
	"handle": "final-sale",
	"id": 372641478
}, {
	"order": 19,
	"type": "customlink",
	"label": "Custom Link",
	"title": "Gift Cards for Online Purchases",
	"url": "\/products\/gift-card"
}, {
	"order": 20,
	"type": "section",
	"label": "Section",
	"title": "Collection"
}, {
	"order": 21,
	"type": "category",
	"label": "Acne Collections",
	"handle": "acne-collections",
	"id": 392914694
}, {
	"order": 22,
	"type": "category",
	"label": "The Basic Skin Care Collections",
	"handle": "the-basic-skin-care-collections",
	"id": 353547206
}, {
	"order": 23,
	"type": "category",
	"label": "The Essential Skin Care Collections",
	"handle": "the-essential-skin-care-collections",
	"id": 353564486
}, {
	"order": 24,
	"type": "category",
	"label": "The Complete Skin Care Collections",
	"handle": "the-complete-skin-care-collections",
	"id": 353564358
}]